import loaderClient from "api/reduxLoaderApi";
import { toast } from "react-toastify";
export const getHelper = async (key) => {
  const client = loaderClient("get")(`/front-end-directories?key=${key}`);
  const res = await client({})({});

  if (res.error) return;
  return res.message;
};
